import AdditionalServiceStatusModalContent from './AdditionalServiceStatusModalContent';
import { IadditionalServiceDataForToolLogistics } from '../../../../types/product.configuration.types';
import { NudosGenericModal, NudosModalContent } from '../../../NudosComponents';
import { ADDITIONAL_SERVICE_STATUS_MODAL_VALUES } from '../../../../types/product.configuration.types';
import './AdditionalServiceStatusModal.scss';

const AdditionalServiceStatusModal = ({
  type,
  additionalServiceData,
  closeModalCallback,
  updateDataCallback,
  isConfiguration,
  orderId
}: {
  type: ADDITIONAL_SERVICE_STATUS_MODAL_VALUES;
  additionalServiceData: IadditionalServiceDataForToolLogistics;
  closeModalCallback: () => void;
  updateDataCallback: () => Promise<void>;
  isConfiguration?: boolean;
  orderId?: string | null;
}) => {
  const getDataByType = () => {
    switch (type) {
      case ADDITIONAL_SERVICE_STATUS_MODAL_VALUES.COMPLETED:
        return {
          title: `Marcar ${isConfiguration ? 'configuración' : 'servicio'} como ${
            isConfiguration ? 'completada' : 'completado'
          }`
        };
      default:
        return {
          title: `Marcar ${isConfiguration ? 'configuración' : 'servicio'} como ${
            isConfiguration ? 'no completada' : 'no completado'
          }`
        };
    }
  };

  const getModalHeight = () => {
    const isCompletedModal = type === ADDITIONAL_SERVICE_STATUS_MODAL_VALUES.COMPLETED;
    return isCompletedModal ? '426px' : '450px';
  };

  const { title } = getDataByType();

  return (
    <div className="additionalServiceStatusModal">
      <NudosGenericModal
        closeModalCallback={() => closeModalCallback()}
        clickOutsideCallback={() => closeModalCallback()}
        modalContent={
          <NudosModalContent
            customWidth="580px"
            customHeight={getModalHeight()}
            toCloseModal={closeModalCallback}
            modalContentTitle={title}
            CustomModalComponent={
              <AdditionalServiceStatusModalContent
                type={type}
                closeModalCallback={closeModalCallback}
                updateDataCallback={updateDataCallback}
                additionalServiceData={additionalServiceData}
                isConfiguration={isConfiguration}
                orderId={orderId}
              />
            }
          />
        }
      />
    </div>
  );
};

export default AdditionalServiceStatusModal;
